import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import {Box, Typography} from '@material-ui/core';
import propTypes from 'helpers/propTypes';

const useStyles = makeStyles(theme => ({
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    display: 'block',
  },
}));

const Project = ({page, gutterBottom, className, children, ...rest}) => {
  const classes = useStyles();

  return (
    <Box marginBottom={gutterBottom ? 4 : 0} className={className} {...rest}>
      <Typography variant="button" color="textSecondary" className={classes.title}>
        {page.title}
      </Typography>
      {children}
    </Box>
  );
};

Project.propTypes = {
  className: PropTypes.string,
  gutterBottom: PropTypes.bool,
  page: propTypes.page.isRequired,
};

export default Project;
